<template>
    <v-bottom-navigation
        :elevation="3"
        height="69">
        <div class="tw-relative tw-mx-2 tw-w-full">
            <div
                id="btn-bg"
                class="tw-absolute tw-top-1/2 tw-h-11 tw-w-20 -tw-translate-x-1/2 -tw-translate-y-1/2 tw-rounded-full tw-bg-primary tw-shadow-lg"
                :style="{
                    left: `${bgLeft}%`,
                    opacity: activeButtonIndex !== -1 ? 1 : 0,
                }"></div>
            <v-btn
                v-for="(button, idx) in buttons"
                :key="idx"
                :active="false"
                :class="['bottom-navigation-button tw-absolute tw-top-1/2 tw-h-11 tw-pe-[10px] tw-ps-2', isButtonActive(button.to.name) ? 'tw-z-[1] tw-text-white' : 'tw-z-0']"
                :elevation="0"
                :ripple="false"
                rounded="xl"
                :style="{
                    left: `${buttonOffset * idx + buttonOffset / 2}% `,
                }"
                :to="button.to"
                :value="button.value"
                variant="text">
                <span class="tw-flex tw-flex-col tw-items-center tw-justify-center tw-gap-1">
                    <component
                        :is="button.icon"
                        v-bind="isButtonActive(button.to.name) && button.iconActiveBinds ? button.iconActiveBinds : {}"
                        class="tw-size-[18px]"
                        :class="{
                            'tw-text-primary': button.value == 'news' && isButtonActive(button.to.name),
                        }" />
                    <span class="bottom-navigation-label tw-text-[10px] tw-normal-case tw-tracking-[.075em]">
                        <!-- {{ $t(button.label) }} -->
                        <CategoryName
                            class="!tw-font-medium tw-capitalize"
                            :name="button.label" />
                    </span>
                </span>
            </v-btn>
        </div>
    </v-bottom-navigation>
</template>

<script setup lang="ts">
    import NewsIcon from '@/components/icons/News.vue';
    import MoreIcon from '@/components/icons/More.vue';
    import MotorIcon from '@/components/icons/Motor.vue';
    import OpinionIcon from '@/components/icons/Opinion.vue';
    import TVIcon from '@/components/icons/TV.vue';
    import { useI18n } from 'vue-i18n';

    const { t } = useI18n();
    const $route = useRoute();
    const bgLeft = ref(0);

    const buttons = computed(() => [
        {
            icon: NewsIcon,
            label: 'pages.news.title',
            value: 'news',
            to: { name: 'NewsLayout' },
            style: {
                active: ['tw-w-10'],
            },
        },
        // {
        //     icon: MotorIcon,
        //     label: 'BottomBar.motor24h',
        //     value: 'motor',
        //     to: { name: 'MotorLayout' },
        //     style: {
        //         active: ['tw-w-12'],
        //     },
        //     iconActiveBinds: {
        //         background: 'currentColor',
        //         stroke: 'transparent',
        //     },
        // },
        {
            icon: TVIcon,
            label: 'categories.tv24h',
            value: 'tv',
            to: { name: 'TV24h' },
            style: {
                active: ['tw-w-8'],
            },
        },
        // {
        //     icon: OpinionIcon,
        //     label: 'BottomBar.opinion',
        //     value: 'opinion',
        //     to: { name: 'Opinions' },
        //     style: {
        //         active: ['tw-w-10'],
        //     },
        // },
        {
            icon: MoreIcon,
            label: 'BottomBar.more',
            value: 'more',
            to: { name: 'More' },
            style: {
                active: ['tw-w-6'],
            },
        },
    ]);

    const buttonOffset = computed(() => {
        // calculate the offset for the buttons based on the number of buttons
        return 100 / buttons.value.length;
    });

    function isButtonActive(routeName: string) {
        // check if the current route name matches the button's route name or any of its parents
        return $route.name === routeName || $route.matched.some((record) => record.name === routeName);
    }

    const activeButtonIndex = computed(() => {
        // find the index of the active button
        return buttons.value.findIndex((button) => isButtonActive(button.to.name));
    });

    watch(
        () => $route.name,
        () => {
            // find the index of the active button
            if (activeButtonIndex.value !== -1) {
                // calculate the left position for the background
                bgLeft.value = buttonOffset.value * activeButtonIndex.value + buttonOffset.value / 2;
            }
        },
        { immediate: true },
    );
</script>

<style lang="scss">
    .v-bottom-navigation__content a,
    .v-bottom-navigation__content a svg {
        // animation for width change
        transition: color 0.3s ease-in-out;
    }
    .v-bottom-navigation__content a svg * {
        // animation for width change
        transition:
            fill 0.3s ease-in-out,
            stroke 0.3s ease-in-out;
    }

    .bottom-navigation-button {
        transform: translateY(-50%) translateX(-50%);
    }

    #btn-bg {
        transition: left 0.3s ease-in-out;
    }

    .v-btn--selected .bottom-navigation-label svg * {
        fill: white !important;
    }
</style>
